import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CreateOffer from "./offerComponents/CreateOffer";
import { singleAuctionDetails } from "../../../redux/action/singleAuction";
import OfferListTable from "../dashboard/singleAuction/table/OfferListTable";
import AuctionSchedule from "../dashboard/comman/AuctionSchedule";

function CreateOfferForAuction() {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { singleAuctionData, loading } = useSelector(
    (pre) => pre?.singleAuction
  );

  useEffect(() => {
    dispatch(singleAuctionDetails(id));
  }, [dispatch, id]);

  return (
    <div className="mt-1">
      <div className="valign-wrapper space-between">
        <span className={`valign-wrapper`} style={{ gap: "25px" }}>
          <span
            className="material-icons-outlined pointer"
            onClick={() => navigate(-1)}
          >
            arrow_back
          </span>
          <h3>Create Offer</h3>
        </span>
      </div>
      <div className={`flex column gap-1`}>
        <AuctionSchedule
          singleAuctionData={singleAuctionData}
          loading={loading}
        />
        {singleAuctionData?.offers?.length !== 0 && (
          <OfferListTable
            auctionType={singleAuctionData?.auctionType}
            offers={singleAuctionData?.offers}
            loading={loading}
          />
        )}
        <div className="full-width">
          <CreateOffer auctionType={singleAuctionData?.auctionType} />
        </div>
      </div>
    </div>
  );
}

export default CreateOfferForAuction;
